import { useEffect } from "react";
import { useForm } from "react-hook-form";

import {
    IDadosParaCadastroEmailReceptivo,
    IEmailReceptivo,
} from "../../../../../../../../Interfaces/Geral/GestaoDeCadastro/Emailconta/EmailReceptivoInterface";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import { useState } from "react";
import { ICategoriaAtendimento } from "../../../../../../../../Interfaces/Geral/GestaoDeCadastro/CategoriaAtendimento/CategoriaAtendimentoInterface";
import { ListarCategoriasAtendimentosController } from "../../../../../../../../Controllers/Geral/GestaoDeCadastros/CategoriaAtendimento";
import {
    AtualizarEmailReceptivoController,
    CadastrarEmailReceptivoController,
} from "../../../../../../../../Controllers/Geral/GestaoDeCadastros/EmailConta/EmailReceptivoController";

interface ICadastrarEmailReceptivoProps {
    setShow: (b: boolean) => void;
    updateList: () => void;
    dadosParaCadastro: IDadosParaCadastroEmailReceptivo;
    emailReceptivo?: IEmailReceptivo;
}

export default function CadastrarEditarEmailReceptivo(
    props: ICadastrarEmailReceptivoProps
) {
    const { register, handleSubmit, formState, reset } =
        useForm<IEmailReceptivo>();

    const [lstCategoriaAtendimento, setLstCategoriaAtendimento] =
        useState<Array<ICategoriaAtendimento>>();

    const onSubmit = (formData: IEmailReceptivo) => {
        const execFunction = props.emailReceptivo
            ? AtualizarEmailReceptivoController
            : CadastrarEmailReceptivoController;
        const execParams = props.emailReceptivo
            ? {
                  ...formData,
                  ID_EMAIL_CONTA_CONFIG:
                      props.emailReceptivo.ID_EMAIL_CONTA_CONFIG,
              }
            : formData;

        execFunction(execParams).then(() => {
            props.setShow(false);
            reset();
            props.updateList();
        });
    };

    useEffect(() => {
        if (props.emailReceptivo) {
            updateCategoriaAtendimento(props.emailReceptivo.ID_TIPO_CASO || 0);
        }
    }, [props.emailReceptivo]);

    function updateCategoriaAtendimento(idTipoCaso: number) {
        ListarCategoriasAtendimentosController(idTipoCaso).then((res) => {
            setLstCategoriaAtendimento(res);
        });
    }

    return (
        <>
            {!props.emailReceptivo && (
                <div className="text-center mb-10 mb-lg-20 ">
                    <h2 className="font-weight-bold">
                        Cadastro de E-mail Receptivo
                    </h2>
                    <p className="text-muted font-weight-bold">
                        Selecione os dados do e-mail receptivo a ser criado
                    </p>
                </div>
            )}
            {(!props.emailReceptivo || lstCategoriaAtendimento) && (
                <form className="form" onSubmit={handleSubmit(onSubmit)}>
                    <div className="form-group border-bottom py-3 b-5 col-12 ">
                        <label htmlFor="ID_EMAIL_CONTA" className="mb-0">
                            Email:
                        </label>
                        <select
                            className={`form-control h-auto border-0 px-0 placeholder-dark-75 ${
                                formState.errors.ID_EMAIL_CONTA && "is-invalid"
                            }`}
                            name="ID_EMAIL_CONTA"
                            id="ID_EMAIL_CONTA"
                            ref={register({
                                required: "Insira o e-mail",
                            })}
                            defaultValue={props.emailReceptivo?.ID_EMAIL_CONTA}
                        >
                            <option value=""></option>
                            {props.dadosParaCadastro?.lstEmails.map((email) => (
                                <option
                                    key={email.ID_EMAIL_CONTA}
                                    value={email.ID_EMAIL_CONTA}
                                >
                                    {email.DS_USERNAME}
                                </option>
                            ))}
                        </select>
                        <div className="invalid-feedback">
                            {formState.errors.ID_EMAIL_CONTA
                                ? formState.errors.ID_EMAIL_CONTA.message
                                : ""}
                        </div>
                    </div>
                    <div className="form-group border-bottom py-3 b-5 col-12 ">
                        <label
                            htmlFor="ID_TIPO_CANAL_ATENDIMENTO"
                            className="mb-0"
                        >
                            Canal de Atendimento:
                        </label>
                        <select
                            className={`form-control h-auto border-0 px-0 placeholder-dark-75 ${
                                formState.errors.ID_TIPO_CANAL_ATENDIMENTO &&
                                "is-invalid"
                            }`}
                            name="ID_TIPO_CANAL_ATENDIMENTO"
                            ref={register({
                                required: "Insira o canal de atendimento",
                            })}
                            defaultValue={
                                props.emailReceptivo?.ID_TIPO_CANAL_ATENDIMENTO
                            }
                        >
                            <option value=""></option>
                            {props.dadosParaCadastro?.lstCanalAtendimento.map(
                                (canal) => (
                                    <option
                                        key={canal.ID_TIPO_CANAL_ATENDIMENTO}
                                        value={canal.ID_TIPO_CANAL_ATENDIMENTO}
                                    >
                                        {canal.DS_TIPO_CANAL_ATENDIMENTO}
                                    </option>
                                )
                            )}
                        </select>
                        <div className="invalid-feedback">
                            {formState.errors.ID_TIPO_CANAL_ATENDIMENTO
                                ? formState.errors.ID_TIPO_CANAL_ATENDIMENTO
                                      .message
                                : ""}
                        </div>
                    </div>
                    <div className="form-group border-bottom py-3 b-5 col-12 ">
                        <label htmlFor="ID_TIPO_CASO" className="mb-0">
                            Tipo Caso:
                        </label>
                        <select
                            className={`form-control h-auto border-0 px-0 placeholder-dark-75 ${
                                formState.errors.ID_TIPO_CASO && "is-invalid"
                            }`}
                            name="ID_TIPO_CASO"
                            ref={register({
                                required: "Insira o tipo de caso",
                            })}
                            defaultValue={props.emailReceptivo?.ID_TIPO_CASO}
                            onChange={(e) => {
                                const selected = e.target.value;
                                updateCategoriaAtendimento(
                                    Number.parseInt(selected)
                                );
                            }}
                        >
                            <option value=""></option>
                            {props.dadosParaCadastro?.lstTipoCaso.map(
                                (modulo) => (
                                    <option
                                        key={modulo.ID_MODULO}
                                        value={modulo.ID_MODULO}
                                    >
                                        {modulo.DS_MODULO}
                                    </option>
                                )
                            )}
                        </select>
                        <div className="invalid-feedback">
                            {formState.errors.ID_TIPO_CASO
                                ? formState.errors.ID_TIPO_CASO.message
                                : ""}
                        </div>
                    </div>
                    <div className="form-group border-bottom py-3 b-5 col-12 ">
                        <label
                            htmlFor="ID_CATEGORIA_ATENDIMENTO"
                            className="mb-0"
                        >
                            Categoria de Atendimento:
                        </label>
                        <select
                            className={`form-control h-auto border-0 px-0 placeholder-dark-75 ${
                                formState.errors.ID_CATEGORIA_ATENDIMENTO &&
                                "is-invalid"
                            }`}
                            name="ID_CATEGORIA_ATENDIMENTO"
                            ref={register({
                                required: "Insira a categoria de atendimento",
                            })}
                            defaultValue={
                                props.emailReceptivo?.ID_CATEGORIA_ATENDIMENTO
                            }
                        >
                            <option value=""></option>
                            {lstCategoriaAtendimento?.map((categoria) => (
                                <option
                                    key={categoria.ID_CATEGORIA_ATENDIMENTO}
                                    value={categoria.ID_CATEGORIA_ATENDIMENTO}
                                >
                                    {categoria.DS_CATEGORIA_ATENDIMENTO}
                                </option>
                            ))}
                        </select>
                        <div className="invalid-feedback">
                            {formState.errors.ID_CATEGORIA_ATENDIMENTO
                                ? formState.errors.ID_CATEGORIA_ATENDIMENTO
                                      .message
                                : ""}
                        </div>
                    </div>
                    <div className="form-group border-bottom py-3 b-5 col-12 ">
                        <label htmlFor="ID_DOCUMENTO_TEMPLATE" className="mb-0">
                            Template de Documento
                        </label>
                        <select
                            className={`form-control h-auto border-0 px-0 placeholder-dark-75 ${
                                formState.errors.ID_DOCUMENTO_TEMPLATE &&
                                "is-invalid"
                            }`}
                            name="ID_DOCUMENTO_TEMPLATE"
                            ref={register({
                                required: "Insira a categoria de atendimento",
                            })}
                            defaultValue={
                                props.emailReceptivo?.ID_DOCUMENTO_TEMPLATE
                            }
                        >
                            <option value=""></option>
                            {props.dadosParaCadastro?.lstTemplateDocumento.map(
                                (documentoT) => (
                                    <option
                                        key={documentoT.ID_DOCUMENTO_TEMPLATE}
                                        value={documentoT.ID_DOCUMENTO_TEMPLATE}
                                    >
                                        {documentoT.DS_DOCUMENTO}
                                    </option>
                                )
                            )}
                        </select>
                        <div className="invalid-feedback">
                            {formState.errors.ID_TIPO_CASO
                                ? formState.errors.ID_TIPO_CASO.message
                                : ""}
                        </div>
                    </div>
                    <div className="form-group border-bottom py-3 b-5 col-12">
                        <div className="input-group align-items-center">
                            <input
                                className={`form-control colomun h-auto border-0 mr-4 px-0 placeholder-dark-75 ${
                                    formState.errors.DS_TAG_PROTOCOLO &&
                                    "is-invalid"
                                }`}
                                placeholder="Tag do Protocolo"
                                name="DS_TAG_PROTOCOLO"
                                id="DS_TAG_PROTOCOLO"
                                ref={register({
                                    required: true,
                                })}
                                defaultValue={
                                    props.emailReceptivo?.DS_TAG_PROTOCOLO
                                }
                            />
                            <OverlayTrigger
                                overlay={
                                    <Tooltip id="tooltip-disabled">
                                        Adicionar a palavra NUM_CASO para ser
                                        substituído pelo número da solicitação
                                    </Tooltip>
                                }
                            >
                                <FontAwesomeIcon
                                    icon={faInfoCircle}
                                    size="lg"
                                />
                            </OverlayTrigger>
                        </div>
                        <div className="invalid-feedback">
                            {formState.errors.DS_TAG_PROTOCOLO
                                ? formState.errors.DS_TAG_PROTOCOLO.message
                                : ""}
                        </div>
                    </div>

                    <div className="d-flex flex-wrap justify-content-center align-items-center">
                        <button
                            type="submit"
                            id="kt_login_signin_submit"
                            className="btn btn-capys font-weight-bold px-9 py-4 my-2"
                        >
                            {!props.emailReceptivo ? "Cadastrar" : "Editar"}
                        </button>
                    </div>
                </form>
            )}
        </>
    );
}
